(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Lazy A-Z menus
     The header only outputs empty shells ([data-sm-alpha-lazy]). The full
     menus come from sections/sm-alpha-menus.liquid, fetched once on the
     first hover, focus or tap, then copied into every shell (desktop and
     mobile drawer).
  ------------------------------------------------------------------ */
  var alphaMenusDocPromise = null;

  function alphaMenusUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + '?section_id=sm-alpha-menus';
  }

  function fetchAlphaMenusDoc() {
    if (alphaMenusDocPromise) return alphaMenusDocPromise;
    alphaMenusDocPromise = fetch(alphaMenusUrl(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('sm-alpha-menus ' + res.status);
        return res.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      })
      .catch(function (err) {
        /* Allow a retry on the next interaction. The shell keeps its
           "View all" fallback link, so the menu still works. */
        alphaMenusDocPromise = null;
        throw err;
      });
    return alphaMenusDocPromise;
  }

  function loadAlphaMenus() {
    if (!document.querySelector('.sm-alpha-menu[data-sm-alpha-lazy]')) {
      return Promise.resolve();
    }
    return fetchAlphaMenusDoc()
      .then(function (doc) {
        /* Runs on every call so shells re-rendered by the theme editor
           get filled too. */
        document.querySelectorAll('.sm-alpha-menu[data-sm-alpha-lazy]').forEach(function (shell) {
          var key = shell.getAttribute('data-sm-alpha-menu');
          var source = doc.querySelector('.sm-alpha-menu[data-sm-alpha-menu="' + key + '"]');
          if (!source) return;
          shell.innerHTML = source.innerHTML;
          shell.removeAttribute('data-sm-alpha-lazy');
        });
      })
      .catch(function (err) {
        if (window.console) console.warn(err);
      });
  }

  function initSmHeader() {
    var header = document.querySelector('[data-sm-header]');
    if (!header || header.dataset.smHeaderInit) return;
    header.dataset.smHeaderInit = 'true';

    var overlay = document.querySelector('[data-sm-header-overlay]');
    var openItem = null;

    function clearAlphaPanels(menu) {
      if (!menu) return;
      menu.querySelectorAll('.sm-alpha-menu__letter.is-active').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      menu.querySelectorAll('.sm-alpha-menu__featured-link.is-active').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      menu.querySelectorAll('.sm-alpha-menu__panel--items.is-visible').forEach(function (panel) {
        panel.classList.remove('is-visible');
      });
    }

    function openAlphaPanel(menu, panelKey, trigger) {
      clearAlphaPanels(menu);
      if (trigger) trigger.classList.add('is-active');
      var panel = menu.querySelector('[data-sm-alpha-panel="' + panelKey + '"]');
      if (panel) panel.classList.add('is-visible');
    }

    function openDefaultAlphaPanel(menu) {
      if (!menu) return;
      var featuredBtn = menu.querySelector('[data-sm-alpha-featured]');
      if (menu.querySelector('[data-sm-alpha-panel="featured"]') && featuredBtn) {
        openAlphaPanel(menu, 'featured', featuredBtn);
      }
    }

    function resetNavPanelPosition(panel) {
      if (!panel) return;
      panel.style.left = '';
    }

    function positionNavDropdown(item) {
      if (!item) return;
      var panel = item.querySelector('.sm-alpha-menu, .sm-header__dropdown');
      if (!panel) return;

      resetNavPanelPosition(panel);

      requestAnimationFrame(function () {
        var padding = 24;
        var rect = panel.getBoundingClientRect();
        if (rect.right > window.innerWidth - padding) {
          panel.style.left = (window.innerWidth - padding - rect.right) + 'px';
        }
      });
    }

    function closeAll() {
      if (openItem) {
        openItem.classList.remove('is-open');
        openItem = null;
      }
      if (overlay) overlay.classList.remove('is-visible');
      header.querySelectorAll('.sm-alpha-menu, .sm-header__dropdown').forEach(function (panel) {
        if (panel.classList.contains('sm-alpha-menu')) clearAlphaPanels(panel);
        resetNavPanelPosition(panel);
      });
      document.querySelectorAll('#NavDrawer .sm-alpha-menu').forEach(clearAlphaPanels);
      document.dispatchEvent(new CustomEvent('sm-header:close-search'));
    }

    function openNavItem(item) {
      if (openItem === item) {
        closeAll();
        return;
      }
      document.dispatchEvent(new CustomEvent('sm-header:close-search'));
      if (openItem) {
        openItem.classList.remove('is-open');
        openItem = null;
      }
      header.querySelectorAll('.sm-alpha-menu').forEach(function (menu) {
        clearAlphaPanels(menu);
        resetNavPanelPosition(menu);
      });
      header.querySelectorAll('.sm-header__dropdown').forEach(resetNavPanelPosition);
      document.querySelectorAll('#NavDrawer .sm-alpha-menu').forEach(clearAlphaPanels);
      item.classList.add('is-open');
      openItem = item;
      if (overlay) overlay.classList.add('is-visible');

      var isAlpha = item.classList.contains('sm-header__nav-item--alpha');
      if (isAlpha || item.classList.contains('sm-header__nav-item--dropdown')) {
        positionNavDropdown(item);
      }
      if (isAlpha) {
        loadAlphaMenus().then(function () {
          if (openItem !== item) return;
          openDefaultAlphaPanel(item.querySelector('.sm-alpha-menu'));
          positionNavDropdown(item);
        });
      }
    }

    header.querySelectorAll('[data-sm-nav-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = toggle.closest('.sm-header__nav-item');
        if (item) openNavItem(item);
      });
    });

    /* Start fetching as soon as someone shows intent, so the menu is
       usually ready by the time they click. */
    header.querySelectorAll('.sm-header__nav-item--alpha').forEach(function (item) {
      item.addEventListener('pointerenter', loadAlphaMenus, { once: true });
      item.addEventListener('focusin', loadAlphaMenus, { once: true });
    });
    document.querySelectorAll('.js-drawer-open-left').forEach(function (btn) {
      btn.addEventListener('pointerdown', loadAlphaMenus, { once: true });
      btn.addEventListener('click', loadAlphaMenus, { once: true });
    });

    header.querySelectorAll('.sm-header__nav-link:not([data-sm-nav-toggle])').forEach(function (link) {
      link.addEventListener('click', function () {
        closeAll();
      });
    });

    /* Letter and Featured buttons are injected after load, so listen at
       the document level instead of binding to each button. */
    document.addEventListener('click', function (e) {
      var letterBtn = e.target.closest && e.target.closest('[data-sm-alpha-letter]');
      var featuredBtn = !letterBtn && e.target.closest && e.target.closest('[data-sm-alpha-featured]');
      var btn = letterBtn || featuredBtn;
      if (!btn) return;

      e.preventDefault();
      if (letterBtn && btn.classList.contains('is-empty')) return;

      var menu = btn.closest('.sm-alpha-menu');
      if (!menu) return;

      openAlphaPanel(menu, letterBtn ? btn.dataset.smAlphaLetter : 'featured', btn);
      var navItem = menu.closest('.sm-header__nav-item--alpha');
      if (navItem) positionNavDropdown(navItem);
    });

    if (overlay) {
      overlay.addEventListener('click', closeAll);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    document.addEventListener('click', function (e) {
      if (header.contains(e.target)) return;
      if (e.target.closest('#NavDrawer')) return;
      closeAll();
    });

    document.addEventListener('sm-header:close-nav', function () {
      if (openItem) {
        openItem.classList.remove('is-open');
        openItem = null;
      }
      header.querySelectorAll('.sm-alpha-menu').forEach(clearAlphaPanels);
    });

    /* Mobile nav - parent link toggles submenu instead of navigating */
    var navDrawer = document.getElementById('NavDrawer');
    if (navDrawer && !navDrawer.dataset.smMobileNavInit) {
      navDrawer.dataset.smMobileNavInit = 'true';

      navDrawer.addEventListener('click', function (e) {
        var link = e.target.closest('.mobile-nav__has-sublist > .mobile-nav__link');
        if (!link) return;

        e.preventDefault();
        var hasSublist = link.closest('.mobile-nav__has-sublist');
        if (hasSublist) {
          hasSublist.classList.toggle('mobile-nav--expanded');
          var item = link.closest('.mobile-nav__item');
          if (hasSublist.classList.contains('mobile-nav--expanded')) {
            loadAlphaMenus().then(function () {
              if (!hasSublist.classList.contains('mobile-nav--expanded')) return;
              openDefaultAlphaPanel(item ? item.querySelector('.sm-alpha-menu') : null);
            });
          } else {
            clearAlphaPanels(item ? item.querySelector('.sm-alpha-menu') : null);
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmHeader);
  } else {
    initSmHeader();
  }

  document.addEventListener('shopify:section:load', initSmHeader);
})();
/* Timber cancels touchmove on #PageContainer to stop the page scrolling
   behind an open drawer. #NavDrawer is inside that container, so the
   drawer never gets the gesture either. Let drawer touches through. */
document.addEventListener('touchmove', function (e) {
  if (e.target.closest && e.target.closest('#NavDrawer')) {
    e.stopPropagation();
  }
}, true);
